"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHVACStatusForNoSensor = exports.getHVACStatusForNoData = exports.calculateHVACStatus = exports.FilterReplacementStatus = exports.FilterStatus = exports.filterThresholdForValue = exports.FilterThresholds = void 0;
exports.FilterThresholds = {
    good: { low: 61, high: 100 },
    warning: { low: 41, high: 60 },
    alert: { low: 0, high: 40 },
};
const filterThresholdForValue = (value) => {
    for (const [key, threshold] of Object.entries(exports.FilterThresholds)) {
        if (value >= threshold.low && value <= threshold.high) {
            return key;
        }
    }
    return undefined;
};
exports.filterThresholdForValue = filterThresholdForValue;
var FilterStatus;
(function (FilterStatus) {
    FilterStatus["FilterGood"] = "filterGood";
    FilterStatus["ReplaceFilter"] = "replaceFilter";
    FilterStatus["ReplaceFilterUrgent"] = "replaceFilterUrgent";
    FilterStatus["NoData"] = "noData";
    FilterStatus["NoSensor"] = "noSensor";
})(FilterStatus = exports.FilterStatus || (exports.FilterStatus = {}));
var FilterReplacementStatus;
(function (FilterReplacementStatus) {
    FilterReplacementStatus["FilterChangeUpcoming"] = "FilterChangeUpcoming";
    FilterReplacementStatus["FilterChangeOverdue"] = "FilterChangeOverdue";
    FilterReplacementStatus["HVACFilterAlert"] = "HVACFilterAlert";
    FilterReplacementStatus["HVACFilterAlertModerate"] = "HVACFilterAlertModerate";
    FilterReplacementStatus["HVACFilterAlertCritical"] = "HVACFilterAlertCritical";
    FilterReplacementStatus["ServiceRequested"] = "ServiceRequested";
    FilterReplacementStatus["FilterOrdered"] = "FilterOrdered";
    FilterReplacementStatus["NoFilterChangeNeeded"] = "NoFilterChangeNeeded";
})(FilterReplacementStatus = exports.FilterReplacementStatus || (exports.FilterReplacementStatus = {}));
const calculateHVACStatus = (percentPressure) => {
    const thresholdCategory = (0, exports.filterThresholdForValue)(percentPressure) || 'good';
    let filterReplacementStatus = null;
    let filterStatus;
    let replacementTime;
    switch (thresholdCategory) {
        case 'good':
            filterStatus = FilterStatus.FilterGood;
            replacementTime = 'inThreeMonths';
            break;
        case 'warning':
            filterStatus = FilterStatus.ReplaceFilter;
            replacementTime = 'inTwoWeeks';
            filterReplacementStatus = FilterReplacementStatus.FilterChangeUpcoming;
            break;
        case 'alert':
            filterStatus = FilterStatus.ReplaceFilterUrgent;
            replacementTime = 'now';
            filterReplacementStatus = FilterReplacementStatus.FilterChangeOverdue;
            break;
        default:
            filterStatus = FilterStatus.FilterGood;
            replacementTime = 'inThreeMonths';
    }
    return {
        filterStatus,
        replacementTime,
        hvac: 'hvac',
        filterReplacementStatus,
        thresholdCategory,
    };
};
exports.calculateHVACStatus = calculateHVACStatus;
const getHVACStatusForNoData = () => ({
    filterStatus: FilterStatus.NoData,
    replacementTime: 'unknown',
    hvac: 'hvac',
    filterReplacementStatus: null,
    thresholdCategory: 'good',
});
exports.getHVACStatusForNoData = getHVACStatusForNoData;
const getHVACStatusForNoSensor = () => ({
    filterStatus: FilterStatus.NoSensor,
    replacementTime: 'unknown',
    hvac: 'hvac',
    filterReplacementStatus: null,
    thresholdCategory: 'good',
});
exports.getHVACStatusForNoSensor = getHVACStatusForNoSensor;
